<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div id="contactHeader" class="page-name color-71aa3f">
                        Collector List
                    </div>
                    <!--<button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backContactCreate">Back</button>-->
                </div>
                <div>
                    <div class="admin-page-content">
                        <form id="contactform">
                            <div class="forms-container">
                                <div class="row no-margin">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-success" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="successMsg"></span>
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 hide">
                                        <div class="alert alert-danger" id="alertDenger">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="errorMsg"></span>
                                        </div>
                                    </div>
                                    <!-- <div class="no-margin">
                                        <div class="col-12 forms-block">
                                            <span class="text-danger">** For Alphabet assignment only <strong>A-Z</strong> <strong>a-z</strong> <strong>,</strong> <strong>-</strong> are allowed. "<strong>,</strong>" denotes single alphabet and "<strong>-</strong>" denotes range of alphabets **</span>
                                        </div>
                                        <template v-if="notAssignedAlpha.length > 0">
                                            <div class="col-12 forms-block">
                                                These Alphabet(s) not assigned to any Collector : <span class="text-danger">{{ notAssignedAlpha }}</span>
                                            </div>
                                        </template>
                                    </div> -->
                                    <template v-for="(row, key) in rows">
                                        <div class="col-12 forms-block">
                                            <div class="col-lg-2 col-md-2 col-sm-12 paddingleft0">
                                                <div class="form-label"><strong>{{ row.first_name }}</strong></div>
                                            </div>
                                            <!-- Entity Drop-down -->
                                            <div class="col-lg-8 col-md-8 col-sm-12 paddingleft0">
                                                <strong class="form-label col-md-1">Entity :</strong>
                                                <div class="col-md-11">
                                                    <v-select class="multi-select-list" v-model="row.entity_data"
                                                        :multiple=true
                                                        name="otherEntityId"
                                                        id="otherEntityId"
                                                        label="text"
                                                        :filterable="false"
                                                        :clearable="false"
                                                        :options="row.entity_name"
                                                        :searchable="true"
                                                        placeholder="Select Entity">
                                                    </v-select>
                                                </div>
                                            </div>

                                            <!-- <div class="col-lg-2 col-md-2 col-sm-12 paddingleft0">
                                                <div class="form-label">
                                                    <strong>
                                                        <label>Allow Special <input type="checkbox" id="jack" v-bind:value="collectorAlpha[row.id].id"  v-model="checkedSpecialNames"></label>
                                                    </strong>
                                                </div>
                                            </div> -->
                                             
                                            <!-- <div class="col-lg-1 col-md-1 col-sm-12 paddingleft0">
                                                <div class="form-label"><strong>Assign Alphabet</strong></div>
                                            </div>
                                            <div class="col-lg-6 col-md-6 col-sm-12 paddingleft0">
                                                <input :name="collectorAlpha[row.id].asignedalpha" :id="collectorAlpha[row.id].asignedalpha"
                                                   class="form-control no-resize" v-model="collectorAlpha[row.id].asignedalpha"
                                                   placeholder="A,B,D-F"
                                                   v-validate="'required'"
                                                   maxlength="190">
                                                <div class="requiredstar">*</div>
                                                <span v-show="errors.has('from_'+row.id)" class="help is-danger" v-if="errors.has('from_'+row.id)"><font color="red">First Name is Required</font></span>
                                            </div> -->
                                            <div class="collectore-update-btn col-lg-1 col-md-1 col-sm-12 paddingleft0">
                                                <input id="updateEntityBtn" type="submit" value="Update" class="pull-right btn general-button btn-primary" v-on:click.prevent="updateEntityToCollector(row.id)">
                                                <!-- <input id="addContactBtn" type="submit" value="Save" class="pull-right btn general-button btn-primary" v-on:click.prevent="AddAlphaToCollector(row.id)"> -->
                                            </div>  
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>
</template>

<script>


    // import { headers } from "../../config";
    import {listemployee, configs} from '../../config';

    import Vue from 'vue';
    import vSelect from 'vue-select';
    import VueGoodTable from 'vue-good-table';
    import 'vue-good-table/dist/vue-good-table.css';
    import FrontFooter from '@/components/partials/FrontFooter';
    import {listEmployeeTable} from '../../config';
    import EventBus from '../event-bus';
    import {HTTP} from '../../http-common.js';
    import SessioMixin from '../../mixins/sessionmixin';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    const Swal = require('sweetalert2');

    Vue.use(VueGoodTable);

    export default {
        name: "listemployee",
        components: {
            'app-footer': FrontFooter,
            'v-select': vSelect,
        },
        mixins: [SessioMixin],
        message: 'all',
        firstLoad: 0,

        data: () => ({
                checkedSpecialNames: [],
                first_name: '',
                last_name: '',
                timezone_id: '',
                permissions: [],
                cantAccessPage: true,
                isLoggedIn: false,

                rows: [],
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: 'empid',
                        type: 'desc',
                    },
                    page: 1,
                    perPage: 500,
                    setCurrentPage: 1,
                },
                alphaArr: [
                    {value: "A", text: "A"},
                    {value: "B", text: "B"},
                    {value: "C", text: "C"},
                    {value: "D", text: "D"},
                    {value: "E", text: "E"},
                    {value: "F", text: "F"},
                    {value: "G", text: "G"},
                    {value: "H", text: "H"},
                    {value: "I", text: "I"},
                    {value: "J", text: "J"},
                    {value: "K", text: "K"},
                    {value: "L", text: "L"},
                    {value: "M", text: "M"},
                    {value: "N", text: "N"},
                    {value: "O", text: "O"},
                    {value: "P", text: "P"},
                    {value: "Q", text: "Q"},
                    {value: "R", text: "R"},
                    {value: "S", text: "S"},
                    {value: "T", text: "T"},
                    {value: "U", text: "U"},
                    {value: "V", text: "V"},
                    {value: "W", text: "W"},
                    {value: "X", text: "X"},
                    {value: "Y", text: "Y"},
                    {value: "Z", text: "Z"},
                ],
                collectorAlpha: [],
                notAssignedAlpha: '',
                entityArr: [],
                otherEntityId: '',
            }),
        mounted: function () {
            var self = this;
            self.loadEntity();
            //self.loadFilters('menucollectors', self.columns, self.serverParams,'employeeList');
            self.jumpToPage = self.serverParams.page;
            self.pageCompare = Math.ceil(self.displayPage / 2);
            $("#jumpToPage").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPage(self.jumpToPage)
                }
            });
            /* var first = "a,b,e";
            console.log(first + " : " + self.validAlphaDashComma(first));
            first = "S,U-Z";
            console.log(first + " : " + self.validAlphaDashComma(first)); */
            $(".removeActive").removeClass('active');
            $("#menucollector").addClass('active');
            if (localStorage.getItem("menu_small") == '1') {
                this.menuSmall();
            } else {
                this.menuBig();
            }
            self.showLoader();
            this.loadEmployee();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        methods: {
            AddAlphaToCollector(empid) {
                var self = this;
                //console.log('AddAlphaToCollector', self.collectorAlpha)
                if (self.checkedSpecialNames.length > 1) {
                    $("#errorMsg").html('Only on collector can have special character name assigned.');
                    $(".alert-danger").parent().removeClass('hide');
                    $(".alert-danger").parent().addClass('show');
                    setTimeout(function () {
                        $('.alert-danger').parent().removeClass('show');
                        $('.alert-danger').parent().addClass('hide');
                    }, 5000);
                    return false;
                }
                /* if (self.checkedSpecialNames[0] != 'undefined' && self.collectorAlpha[empid].id == self.checkedSpecialNames[0] && (self.collectorAlpha[empid].from.value == null || self.collectorAlpha[empid].to.value == null || self.collectorAlpha[empid].from.value == '' || self.collectorAlpha[empid].to.value == '')) {
                    //alert('here');
                    //return false;
                } */
                if (self.collectorAlpha[empid].asignedalpha == null || self.collectorAlpha[empid].asignedalpha == '' || !self.validAlphaDashComma(self.collectorAlpha[empid].asignedalpha)) {
                    $("#errorMsg").html('Please assign Alphabets with the proper format');
                    $(".alert-danger").parent().removeClass('hide');
                    $(".alert-danger").parent().addClass('show');
                    setTimeout(function () {
                        $('.alert-danger').parent().removeClass('show');
                        $('.alert-danger').parent().addClass('hide');
                    }, 5000);
                    return false;
                }
                if (self.collectorAlpha[empid].asignedalpha != null || self.collectorAlpha[empid].asignedalpha != '' || self.validAlphaDashComma(self.collectorAlpha[empid].asignedalpha)) {
                    for (var i = 0; i < self.collectorAlpha[empid].asignedalpha.length; i++) {
                        if(i%2){
                            if(self.collectorAlpha[empid].asignedalpha[i] != "-" && self.collectorAlpha[empid].asignedalpha[i] != ","){
                                $("#errorMsg").html('Please use pattern like "A,C,G-J" for "A,C,G,H,I,J" and do not use space');
                                $(".alert-danger").parent().removeClass('hide');
                                $(".alert-danger").parent().addClass('show');
                                setTimeout(function () {
                                    $('.alert-danger').parent().removeClass('show');
                                    $('.alert-danger').parent().addClass('hide');
                                }, 5000);
                                return false;
                                /* console.log(self.collectorAlpha[empid].asignedalpha[i] + " != , or - "); */
                            }
                        }
                    }
                }
                /* if ((self.collectorAlpha[empid].from.value == null || self.collectorAlpha[empid].from.value == '') && (self.collectorAlpha[empid].to.value != '' || self.collectorAlpha[empid].to.value != '')) {
                    //alert('first');
                    $("#errorMsg").html('Please select from and to value.');
                    $(".alert-danger").parent().removeClass('hide');
                    $(".alert-danger").parent().addClass('show');
                    setTimeout(function () {
                        $('.alert-danger').parent().removeClass('show');
                        $('.alert-danger').parent().addClass('hide');
                    }, 5000);
                    return false;
                } */
                /* if ((self.collectorAlpha[empid].to.value == null || self.collectorAlpha[empid].to.value == '') && (self.collectorAlpha[empid].from.value != '' || self.collectorAlpha[empid].from.value != '')) {
                    //alert('second');
                    $("#errorMsg").html('Please select from and to value.');
                    $(".alert-danger").parent().removeClass('hide');
                    $(".alert-danger").parent().addClass('show');
                    setTimeout(function () {
                        $('.alert-danger').parent().removeClass('show');
                        $('.alert-danger').parent().addClass('hide');
                    }, 5000);
                    return false;
                } */

                /* if (self.collectorAlpha[empid].from.value > self.collectorAlpha[empid].to.value) {
                    //alert('From can not be greater than to');
                    $("#errorMsg").html('From can not be greater than to.');
                    $(".alert-danger").parent().removeClass('hide');
                    $(".alert-danger").parent().addClass('show');
                    setTimeout(function () {
                        $('.alert-danger').parent().removeClass('show');
                        $('.alert-danger').parent().addClass('hide');
                    }, 5000);
                    return false;
                } */

                var fields = {
                    collectorAlpha: self.collectorAlpha[empid],
                    checkedSpecialNames: self.checkedSpecialNames,
                };
                // console.log(self.serverParams.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/update/collectoralpha/" + empid,
                    type: "POST",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        // console.log('data', data);
                        self.notAssignedAlpha = data.notAssignedAlpha;
                        // if (self.notAssignedAlpha.length) {
                        //     Swal.fire(
                        //             'Warning !',
                        //             "These Alphabet(s) not assigned to any Collector : <br/><span class='text-danger'>" + self.notAssignedAlpha + "</span>",
                        //             'info'
                        //             );
                        // }
                        $("#successMsg").html('Collector updated successfully.');
                        $(".alert-success").parent().removeClass('hide');
                        $(".alert-success").parent().addClass('show');
                        setTimeout(function () {
                            $('.alert-success').parent().removeClass('show');
                            $('.alert-success').parent().addClass('hide');
                        }, 5000);

                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {

                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 403) {
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-danger").parent().removeClass('hide');
                                $(".alert-danger").parent().addClass('show');
                                setTimeout(function () {
                                    $('.alert-danger').parent().removeClass('show');
                                    $('.alert-danger').parent().addClass('hide');
                                }, 5000);
                            }
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            //self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },
            fillPreviousAlpha() {
                var self = this;
                self.rows.forEach(function (element) {
                    //console.log('fillPreviousAlpha',element);
                    var object = {
                        id: element.id,
                        /* from: {value: element.alpha_from, text: element.alpha_from},
                        to: {value: element.alpha_to, text: element.alpha_to}, */
                        asignedalpha: element.alpha_range
                    };
                    if (element.alpha_special == 1) {
                        self.checkedSpecialNames.push(element.id);
                    }
                    var empAlphaArray = [];
                    //empAlphaArray[element.id] = object;
                    //console.log(object);
                    //self.collectorAlpha.push(empAlphaArray);
                    self.collectorAlpha[element.id] = object;
                    //self.collectorAlpha = self.collectorAlpha.filter(function(v){return v!==''});
                    //console.log('fillPreviousAlpha COl',self.collectorAlpha);

                });
            },
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_access_collector_settings') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            loadEntity: function() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                };
                var fields = {
                    all_option_required:true,
                    role_id: self.loginUserRoleId,
                };
                HTTP.post('/entity',fields, config)
                    .then(response => {
                        // console.log(response.data.content);
                        setTimeout(function(){
                            self.entityArr = response.data.content;
                        },2000)
                        if(self.entityArr && self.entityArr.length > 0) {
                            self.otherEntityId = {text: entityArr.text, value: entityArr.value};
                        }
                    })
                    .catch((err)=>{
                        self.hideLoader();
                        self.catchHandler(err, function () {});
                    });
            },
            updateEntityToCollector(empid) {
                var self = this;
                var fields = {
                    entity_data: self.rows,
                };
                // console.log(self.serverParams.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/update/collectorentity/" + empid,
                    type: "POST",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        // console.log('data', data);
                        $("#successMsg").html('Collector updated successfully.');
                        $(".alert-success").parent().removeClass('hide');
                        $(".alert-success").parent().addClass('show');
                        setTimeout(function () {
                            $('.alert-success').parent().removeClass('show');
                            $('.alert-success').parent().addClass('hide');
                        }, 5000);

                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {

                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 403) {
                                $("#errorMsg").html(jqXHR.responseJSON.message);
                                $(".alert-danger").parent().removeClass('hide');
                                $(".alert-danger").parent().addClass('show');
                                setTimeout(function () {
                                    $('.alert-danger').parent().removeClass('show');
                                    $('.alert-danger').parent().addClass('hide');
                                }, 5000);
                            }
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            //self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },
            loadEmployee: function () {
                var self = this;
                self.serverParams.setCurrentPage = self.serverParams.page;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    messageData: self.message,
                    collector: 'collector'
                };
                //this.storeFilters('menucollectors', self.serverParams, false);
                this.firstLoad = 1;
                // console.log(self.serverParams.perPage);
                self.showLoader();
                $.ajax({
                    url: process.env.ROOT_API + "/get/collectorlist",
                    type: "GET",
                    data: fields,
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.code == '200') {
                            self.rows = data.content.row;
                            // console.log(self.rows);
                            self.fillPreviousAlpha();
                            self.notAssignedAlpha = data.notAssignedAlpha;
                            // if (self.notAssignedAlpha.length) {
                            //     Swal.fire(
                            //             'Warning !',
                            //             "These Alphabet(s) not assigned to any Collector : <br/><span class='text-danger'>" + self.notAssignedAlpha + "</span>",
                            //             'info'
                            //             );
                            // }
                            self.totalRecords = data.content.totalRecords;
                            self.showHidePagination("employeeList", self.totalRecords);
                            self.jumpToPage = self.serverParams.page;
                        }
                        self.paginationDisplayRows = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                        self.hideLoader();
                    },
                    error: function (jqXHR, exception) {
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }


                            self.error = jqXHR.responseJSON.message;
                        }
                        self.hideLoader();
                    }

                });
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
            }


        }
    };
</script>


// WEBPACK FOOTER //
// src/components/employee/ListCollector.vue